
import Home from "./profile_website/Home";
import { BaseService, IGallery, IMember, IProfileWebsite, MemberService, SanitizedResponse } from "../../../services";
import Media from "./profile_website/Media";
import Design from "./profile_website/Design";
import General from "./profile_website/General";
import Billing from "./plan_and_billing/Billing";
import Sessions from "./manage_account/Sessions";
import Schedule from "./profile_website/Schedule";
import * as ReactRouterDom from "react-router-dom";
import ManageData from "./manage_account/ManageData";
import EditProfile from "./manage_account/EditProfile";
import ManagePlan from "./plan_and_billing/ManagePlan";
import TeamHistory from "./profile_website/TeamHistory";
import ProfileNotifications from "./ProfileNotifications";
import Achievements from "./profile_website/Achievements";
import InterestsAndAi from "./manage_account/InterestsAndAi";
import SocialAccounts from "./manage_account/SocialAccounts";
import React from "react";
import { Siren } from "../../shared/ConfirmDialog";
import { i18nManager } from "../../../i18n";
import Gallery from "../../shared/settings/Gallery";
import Merch from "../../shared/settings/Merch";

export interface AccountSettingsProps {
    profile: IMember;
}

function AccountSettings(props: AccountSettingsProps) {

    const { profile } = props;
    const memberService = MemberService.getInstance();
    const merchRivtnAdStateState = React.useState<boolean>();
    const galleryRivtnAdStateState = React.useState<boolean>();
    const profileWebsiteGalleryState = React.useState<IGallery[]>();
    const [profileWebsite, setProfileWebsite] = React.useState<IProfileWebsite>();

    return (<ReactRouterDom.Routes>
        <ReactRouterDom.Route path="/notifications" element={<ProfileNotifications />} />
        {/* plan and billing */}
        <ReactRouterDom.Route path="/billing" element={<Billing profile={profile} />} />
        <ReactRouterDom.Route path="/manage-plan" element={<ManagePlan profile={profile} />} />
        {/* manage account */}
        <ReactRouterDom.Route path="/interests-ai" element={<InterestsAndAi />} />
        <ReactRouterDom.Route path="/sessions" element={<Sessions profile={profile} />} />
        <ReactRouterDom.Route path="/manage-data" element={<ManageData profile={profile} />} />
        <ReactRouterDom.Route path="/edit-profile" element={<EditProfile profile={profile} />} />
        <ReactRouterDom.Route path="/social-accounts" element={<SocialAccounts profile={profile} />} />
        {/* profile website */}
        <ReactRouterDom.Route path="/website/home" element={<Home profile={profile} />} />
        <ReactRouterDom.Route path="/website/media" element={<Media profile={profile} />} />
        <ReactRouterDom.Route path="/website/design" element={<Design profile={profile} />} />
        <ReactRouterDom.Route path="/website/general" element={<General profile={profile} />} />
        <ReactRouterDom.Route path="/website/schedule" element={<Schedule profile={profile} />} />
        <ReactRouterDom.Route path="/website/team-history" element={<TeamHistory profile={profile} />} />
        <ReactRouterDom.Route path="/website/achievements" element={<Achievements profile={profile} />} />
        <ReactRouterDom.Route path="/website/merch" element={<Merch profile={profile} enableRivtnAdState={merchRivtnAdStateState} updateSettings={(enableRivtnAd: boolean) => {
            //merchRivtnAdStateState[1](enableRivtnAd);
            if (!profileWebsite) return;
            memberService.updateProfileWebsite({ ...profileWebsite, merchandise_settings: { ...profileWebsite.merchandise_settings, enable_rivtn_ad: enableRivtnAd } }).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
                Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
            }).catch(BaseService.reportError);
        }} />} />
        <ReactRouterDom.Route path="/website/gallery" element={<Gallery profile={profile} galleryState={profileWebsiteGalleryState}
            previewActionKey="action_label" previewLocationKey="action_location" previewCaptionKey="caption" 
            updateGalleryMethod={memberService.updateProfileWebsiteGallery.bind(memberService)} uploadPath="/omnehost/member/gallery/"
            enableAdLabel={i18nManager.Labels.account.profile_website.gallery.enable_ad} deleteLabel={i18nManager.Labels.account.profile_website.gallery.dialog.delete.title}
            enableRivtnAdState={galleryRivtnAdStateState} addGalleryMethod={memberService.createProfileWebsiteGallery.bind(memberService)} deleteGalleryMethod={memberService.deleteProfileWebsiteGallery.bind(memberService)} 
            createLabel={i18nManager.Labels.account.profile_website.gallery.dialog.add_update.add_media_to_gallery} updateLabel={i18nManager.Labels.account.profile_website.gallery.dialog.add_update.update_media_in_gallery}
            formControls={[
                {
                    type: "file",
                    name: "media_location",
                },
                [
                    {
                        type: "textbox",
                        name: "action_label",
                    },
                    {
                        type: "textbox",
                        name: "action_location",
                    }
                ],
                {
                    name: "caption",
                    type: "textarea",
                },
            ]}
            onUnMount={() => {
                setProfileWebsite(undefined);
            }} fetchGallery={() => {
                if (!profileWebsite) {
                    memberService.getProfileWebsite().then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
                        setProfileWebsite(sanitized);
                    }).catch(BaseService.reportError);
                }
                memberService.getProfileWebsiteGallery().then(({ apiResponse }: SanitizedResponse<IGallery>) => {
                    profileWebsiteGalleryState[1](apiResponse.data?.content);
                }).catch(BaseService.reportError);
            }} updateSettings={(enableRivtnAd: boolean) => {
                //galleryRivtnAdStateState[1](enableRivtnAd);
                if (!profileWebsite) return;
                memberService.updateProfileWebsite({ ...profileWebsite, gallery_settings: { ...profileWebsite.gallery_settings, enable_rivtn_ad: enableRivtnAd } }).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
                    Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
                }).catch(BaseService.reportError);
            }} />} />
    </ReactRouterDom.Routes>);

}

export default AccountSettings;
